module.exports = __webpack_public_path__ + "media/photo/telicom_bgss-ecf13b37.png";